import { FC } from 'react';

interface TopUpButtonProps {
  onClick: () => void;
  disabled?: boolean;
  className?: string;
}

const TopUpButton: FC<TopUpButtonProps> = ({
  onClick,
  disabled = false,
  className = '',
}) => {
  return (
    <button
      onClick={onClick}
      disabled={disabled}
      className={`px-4 py-1 mt-7 rounded-lg bg-indigo-600 text-white hover:bg-indigo-700 disabled:opacity-50 transition-colors ${className}`}
    >
      Top Up
    </button>
  );
};

export default TopUpButton;